import { CountryCode } from '../models/country-code';

/**
 * Flatmaps supported countries from a list of objects containing such field (various case models).
 * @param cases a list of objects containing supported countries
 * @return a list of unique country codes
 */
export function getSupportedCountries(
    cases: { supportedCountries: string[] }[]
): CountryCode[] {
    return [
        ...new Set(cases.flatMap((c) => c.supportedCountries as CountryCode[])),
    ];
}
